import React, { useEffect } from "react";
import Image from "next/image";

import ReactModal from "react-modal";
import CloseIcon from "@/components/_icons/closeIcon";

export const PerksModal = ({ isOpen, onRequestClose, customerPerks }: any) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  const availablePerks = customerPerks?.filter(
    (perk: { available: boolean }) => perk.available
  );
  const unavailablePerks = customerPerks?.filter(
    (perk: { available: boolean }) => !perk.available
  );

  return (
    <ReactModal
      ariaHideApp={false}
      appElement={global?.window?.document?.getElementById("app") || undefined}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="fixed inset-0 flex items-center justify-center"
      overlayClassName="fixed inset-0 bg-black bg-opacity-75 z-50"
    >
      <div className="bg-white sm:rounded-lg shadow-lg w-[100%] h-[100%] sm:h-auto sm:w-full max-w-md md:max-w-lg lg:max-w-xl mx-auto overflow-hidden">
        <div className="flex justify-between items-center px-6 pt-6">
          <h2 className="pt-4 text-4xl text-[32px] font-medium text-[#373737]">
            Perks
          </h2>
          <button
            onClick={onRequestClose}
            className="text-gray-600 hover:text-gray-900"
          >
            <CloseIcon />
          </button>
        </div>
        <div className="py-4 px-6">
          {availablePerks && availablePerks.length > 0 && (
            <div>
              <p className="mb-4 text-[15px] text-md text-[#373737]">
                You have perks available for redemption. You can apply up to 1
                perk at checkout.
              </p>
              <p className="mb-4 text-[15px] text-md text-[#373737]">
                Available perks (Redeem at checkout)
              </p>
            </div>
          )}
          {availablePerks?.map(
            (perk: {
              uuid: string;
              title: string;
              iconUrl: string;
              backgroundUrl: string;
            }) => (
              <div
                className="p-4 rounded-lg gap-2 flex items-center"
                key={perk.uuid}
              >
                <div className="relative w-[48px] h-[48px]">
                  <Image
                    src={perk.backgroundUrl}
                    layout="fill"
                    objectFit="contain"
                    alt={perk.title}
                  />
                  <Image
                    src={perk.iconUrl}
                    layout="fill"
                    objectFit="contain"
                    alt={perk.title}
                  />
                </div>
                <div className="text-black">{perk.title}</div>
              </div>
            )
          )}

          {unavailablePerks?.length > 0 && (
            <>
              <p className="mt-4 mb-4 text-[15px] text-md">In progress</p>
              {unavailablePerks?.map(
                (perk: {
                  uuid: string;
                  title: string;
                  iconUrl: string;
                  backgroundUrl: string;
                  earned: number;
                  required: number;
                }) => {
                  const progressPercentage = Math.min(
                    (perk.earned / perk.required) * 100,
                    100
                  );

                  return (
                    <div
                      className="p-4 rounded-lg flex items-center gap-2 mb-4 shadow-[0_2px_6px_0px_rgba(37,51,56,0.15)]"
                      key={perk.uuid}
                    >
                      <div className="relative w-[48px] h-[48px]">
                        <Image
                          src={perk.backgroundUrl}
                          layout="fill"
                          objectFit="contain"
                          alt={perk.title}
                        />
                        <Image
                          src={perk.iconUrl}
                          layout="fill"
                          objectFit="contain"
                          alt={perk.title}
                        />
                      </div>
                      <div className="text-black flex-1">
                        <div>{perk.title}</div>
                        <div className="w-full h-1 bg-gray-200 rounded-full mt-2">
                          <div
                            className="h-1 bg-yellow-500 rounded-full"
                            style={{ width: `${progressPercentage}%` }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  );
                }
              )}
            </>
          )}
        </div>
      </div>
    </ReactModal>
  );
};
